import { MODALITY, STATUS } from "../components/my-sales/consts";
import {
	SALES_FILTER_HAS_ERRORS,
	SALES_FILTERED,
	SALES_OPEN_CLOSE_FILTER_MODAL,
	SALES_RECEIVED,
	DATA_WAS_REQUESTED,
	SALES_TAB_STATUS_FILTERED,
	SALES_VIEW_MODE,
	SALES_SEARCH_NOT_FOUND,
	SALES_OPEN_CLOSE_SEARCH_MOBILE,
	SALES_OPEN_CLOSE_EXPORT_MODAL,
	EXPORT_WAS_REQUESTED,
	EXPORT_FINISHED,
	EXPORT_FINISHED_MODAL_CLOSED,
	EXPORT_FINISHED_MODAL,
	SALES_FIND_ERROR,
	SALES_HAS_FIELD_ERRORS,
	SALES_SEARCH_IS_OPEN,
	SALES_SEARCH_RECEIVED,
	DATA_SEARCH_WAS_REQUESTED,
	EXPORT_IRPF_REQUESTED,
	EXPORT_IRPF_FINISH,
	OPEN_CLOSE_GENERAL_ALERT,
	EXPORT_DOCS_FINISHED
} from "../shared/constants";
import { returnUserJWT } from "../shared/utils";

let user = returnUserJWT();
let sendToEmail = user ? user.email : "";

const INITIAL_STATE = {
	salesData: {
		sales: [],
		resaleCount: 0,
		suspendedCount: 0,
		frozenCount: 0
	},
	statusSaleFiltered: {},
	filteredStatements: {
		numPag: 1,
		salesPerPage: 25,
		dateMethod: {
			label: "Personalizado",
			value: 2
		},
		periodType: 0,
		status: STATUS.ALL,
		sendToEmail: sendToEmail,
		idsFidelity: [],
		checkboxStatus: {
			canceled: true,
			toReceive: true,
			received: true,
			resale: true,
			others: true
		},
		modality: MODALITY.ALL,
		checkboxModality: {},
		fileType: "email"
	},
	errors: {},
	filterErrors: {},
	viewMode: "block",
	searchWebIsOpen: false,
	generalAlertOpen: false,
	generalAlertMsg: ""
};

const SalesReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case DATA_WAS_REQUESTED:
			return {
				...state,
				isFetching: true,
				findSalesHasError: false,
				searchNotFound: false,
				searchIsFetching: false
			};
		case DATA_SEARCH_WAS_REQUESTED:
			return {
				...state,
				searchIsFetching: true,
				findSalesHasError: false,
				searchNotFound: false,
				searched: action.payload,
				filteredStatements: {
					...state.filteredStatements,
					status: 0
				}
			};
		case EXPORT_WAS_REQUESTED:
			return {
				...state,
				isExportFetching: action.payload
			};
		case EXPORT_IRPF_REQUESTED:
			return {
				...state,
				...action.payload,
				isIRPFFetching: true
			};
		case EXPORT_IRPF_FINISH:
			return {
				...state,
				isIRPFFetching: false
			};
		case SALES_RECEIVED:
			return {
				...state,
				salesData: action.payload.data,
				isFetching: false,
				searched: "",
				searchNotFound: action.payload.data.sales.length === 0
			};
		case EXPORT_FINISHED:
			return {
				...state,
				isExportFetching: false,
				isExportFinished: true,
				modalExportIsOpen: false
			};
		case EXPORT_DOCS_FINISHED:
			return {
				...state,
				isExportFetching: false,
				modalExportIsOpen: false
			};
		case SALES_FILTERED:
			return {
				...state,
				filteredStatements: {
					...action.payload.filters,
					checkboxStatus: {
						resale: action.payload.filters.status === 4 || action.payload.filters.status === 0,
						canceled: action.payload.filters.status === 3 || action.payload.filters.status === 0,
						toReceive: action.payload.filters.status === 2 || action.payload.filters.status === 0,
						received: action.payload.filters.status === 1 || action.payload.filters.status === 0
					}
				}
			};
		case SALES_TAB_STATUS_FILTERED:
			return {
				...state,
				statusSaleFiltered: action.payload
			};
		case SALES_VIEW_MODE:
			return {
				...state,
				viewMode: action.payload
			};
		case SALES_OPEN_CLOSE_FILTER_MODAL:
			return {
				...state,
				modalFilterIsOpen: action.payload
			};
		case SALES_OPEN_CLOSE_EXPORT_MODAL:
			return {
				...state,
				modalExportIsOpen: action.payload
			};
		case EXPORT_FINISHED_MODAL:
			return {
				...state,
				isExportFinished: action.payload
			};
		case SALES_OPEN_CLOSE_SEARCH_MOBILE:
			return {
				...state,
				searchWebIsOpen: action.payload
			};
		case SALES_SEARCH_RECEIVED:
			return {
				...state,
				salesData: action.payload.request.data,
				searched: action.payload.searched,
				searchIsFetching: false,
				searchNotFound: action.payload.request.data.sales.length === 0
			};
		case SALES_FIND_ERROR:
			return {
				...state,
				searchError: action.payload,
				findSalesHasError: true,
				isFetching: false,
				salesData: { sales: [] }
			};
		case SALES_HAS_FIELD_ERRORS:
			return {
				...state,
				errors: action.payload
			};
		case SALES_SEARCH_IS_OPEN:
			return {
				...state,
				searchIsOpen: action.payload
			};
		case OPEN_CLOSE_GENERAL_ALERT:
			return {
				...state,
				...action.payload
			};

		default:
			return state;
	}
};

export default SalesReducer;
